// eslint-disable-next-line no-restricted-imports
import { version } from '../../package.json';

const occlVersion = 'v3';

export const config = {
  version,
  occl: {
    theme: (occluri: string) => `${occluri}/${occlVersion}/pre-sets/coms/bundle.css`,
    vendors: (occluri: string) => [{
      src: `${occluri}/${occlVersion}/library/vendors.js`,
      module: true,
      ignoreNotFound: false,
    }, {
      src: `${occluri}/${occlVersion}/components/modal/bundle.js`,
      module: true,
      ignoreNotFound: true,
    }],
    bundle: (occluri: string) => [{
      src: `${occluri}/${occlVersion}/pre-sets/coms/bundle.js`,
      module: true,
      namespace: 'coms', // only needed here
    }],
  },
  bugsinkDsns: {
    dev: 'https://55affe8bac344b9b8119600451bd322c@bugsink.high.coms-dev.aws.de.pri.o2.com/1',
    prod: undefined,
  },
};
